import {
    AdsClickOutlined,
    AutoModeOutlined,
    CallSplitOutlined,
    CreditCardOutlined,
    DesktopWindowsOutlined,
    FlagOutlined,
    LanguageOutlined,
    MyLocationOutlined,
    PeopleOutline,
    SecurityOutlined,
    SettingsOutlined,
    ShareOutlined,
    SpeedOutlined,
    TouchAppOutlined,
    TravelExploreOutlined,
    FindInPageOutlined,
    TrackChangesOutlined,
    VpnKeyOutlined,
    ReceiptLongOutlined, ShieldOutlined, TaskAltOutlined, SendOutlined, HubOutlined
} from '@mui/icons-material';

const administrators = ['owner', 'manager'];
export const sidebarWidth = 220;
export const sidebarCollapsedWidth = 72;

const groups = [
    {title: '', items: [
        {label: 'Dashboard', to: '/dashboard', matches: ['/'], icon: SpeedOutlined},
        {label: 'Ads manager', to: '/campaigns', icon: MyLocationOutlined},
        {label: 'Automation', to: '/automation', icon: AutoModeOutlined, badge: 'Beta'}
    ]},
    {title: 'Resources', items: [
        {label: 'Offers', to: '/offers', icon: FlagOutlined},
        {label: 'Landings', to: '/landings', icon: DesktopWindowsOutlined},
        {label: 'Flows', to: '/flows', icon: CallSplitOutlined},
        {label: 'Traffic sources', to: '/traffic-sources', icon: AdsClickOutlined},
        {label: 'Affiliate networks', to: '/affiliate-networks', icon: HubOutlined}
    ]},
    {title: 'Management', items: [
        {label: 'Integrations', to: '/settings/integrations', icon: ShareOutlined, roles: administrators},
        {label: 'Custom conversions', to: '/settings/custom-events', icon: TrackChangesOutlined},
        {label: 'Domains', to: '/settings/domains', icon: LanguageOutlined, roles: administrators},
        {label: 'Websites', to: '/websites/domains', matches: ['/websites'], icon: TravelExploreOutlined, roles: administrators}
    ]},
    {title: 'Logs', items: [
        {label: 'Logs', key: 'logs', icon: FindInPageOutlined, children: [
            {label: 'Clicks', to: '/log/clicks', icon: TouchAppOutlined},
            {label: 'Conversions', to: '/log/conversions', icon: TaskAltOutlined},
            {label: 'Postbacks', to: '/log/postbacks', icon: SendOutlined}
        ]}
    ]},
    {title: 'Account', items: [
        {label: 'Settings', key: 'settings', icon: SettingsOutlined, children: [
            {label: 'General settings', to: '/settings/general', icon: SettingsOutlined},
            {label: 'Subscription', to: '/settings/subscription', icon: CreditCardOutlined, roles: ['owner']},
            {label: 'Team & workspaces', to: '/settings/team/members', matches: ['/settings/team'], icon: PeopleOutline, roles: administrators},
            {label: 'Bot detection', to: '/settings/bot-detection', matches: ['/settings/bot-rules'], icon: ShieldOutlined, roles: administrators},
            {label: 'Landing protection', to: '/settings/landing-protection/php', matches: ['/settings/landing-protection'], icon: SecurityOutlined},
            {label: 'API access', to: '/settings/api-access', icon: VpnKeyOutlined, roles: administrators},
            {label: 'Refer & earn', to: '/settings/referral', icon: ReceiptLongOutlined, roles: ['owner']}
        ]}
    ]}
];

export function getNavigationGroups(role) {
    const allowed = item => !item.roles || item.roles.includes(role);
    return groups.map(group => ({...group, items: group.items.filter(allowed).map(item => (
        item.children ? {...item, children: item.children.filter(allowed)} : item
    ))})).filter(group => group.items.length);
}

export function isNavigationActive(item, pathname) {
    return [item.to, ...(item.matches || [])].filter(Boolean).some(path => (
        pathname === path || (path !== '/' && pathname.startsWith(`${path}/`))
    ));
}
